import { Vue, Component, Watch } from 'vue-property-decorator';
import { WatchOptions } from 'vue';
import VueI18n from 'vue-i18n';
import { Translation } from '@/models/Translation';


@Component
export default class AdminTranslation extends Vue {
  public translations: Translation[] = [];
  public title: string = '';

  @Watch('$i18n.locale', { immediate: true, deep: true } as WatchOptions)
  protected onLocaleChanged(value: string, oldValue: string) {
    this.translations = [];
    this.title = `Translations ${this.$route.params.screening.toUpperCase()} - ${this.$i18n.locale.toUpperCase()}`;
    const messages =  this.$i18n.messages as VueI18n.LocaleMessages;

    const obj = JSON.parse(JSON.stringify(messages[value]));
    this.getOjectProperties(obj, '');
  }

  private getOjectProperties(obj: any, parent: string) {
    const array = Object.getOwnPropertyNames(obj);
    array.forEach((x: any) => {
      if (typeof obj[x] === 'object') {
        if (parent) {
          this.getOjectProperties(obj[x], parent + '.' + x);
        } else {
          this.getOjectProperties(obj[x], x);
        }
      } else {
        this.translations.push({
          key: parent + '.' + x,
          caption: this.$i18n.t(parent + '.' + x) as string,
        });
      }
    });
  }
}
